"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postJSON = exports.getData = void 0;
var logger_1 = require("./logger");
var request_helper_1 = require("./request/request-helper");
function getData(headers, url) {
    return request_helper_1.makeRequest(headers, 'GET', url).then(function (data) { return (data); }).catch(function (err) {
        logger_1.logError(err);
    });
}
exports.getData = getData;
function postJSON(json, headers, url, retries) {
    return request_helper_1.makeRequest(headers, 'POST', url, json, retries).then(function (data) { return (data); }).catch(function (err) {
        logger_1.logError(err);
    });
}
exports.postJSON = postJSON;
